import { graphql } from "gatsby"
import React from "react"
import Layout from "../../components/layout"
import { RenderRichContent } from "../../components/RenderRichContent/RenderRichContent"
import { MetaDirectives } from "../../components/MetaDirectives/MetaDirectives"
import * as styles from "../SectorPage/SectorPage.module.scss"
import DemoRequestBanner from "../../components/DemoRequestBanner/DemoRequestBanner"
import ImageTextBlockSector from "../../components/ImageTextBlock/ImageTextBlockSector"
import FreeDemoBarSector from "../../components/FreeDemoBar/FreeDemoBarSector"
import Slider from "../../components/slider/Slider"
import TextBlock from "../../components/TextBlock/TextBlock"
import ReferenceContainer from "../../components/ReferenceContainer/ReferenceContainer"
import QuotesComponent from "../../components/QuotesComponent/QuotesComponent"
import NewSlider from "../../components/slider/SliderInfinity"
import NewPricingCard from "../../components/PricingCard/NewPricingCard"
import CustomerSlider from "../../components/CustomerSlider/CustomerSlider"
import WorkingdayImageTextBlock from "../../components/HomepageImageTextBlocks/WorkingdayImageTextBlock.jsx"
import HomepageBlogCard from "../../components/BlogCard/HomepageBlogCard.jsx" // New import

export function Head(props) {
  const data =
    props.data.allContentfulEdc22ContentPageImportedEdControlsPages.nodes[0]
  let pageContext
  const slugs = props.data.General.nodes

  const slugMaker = () => {
    let canonicalList = []
    slugs.forEach(slug => {
      canonicalList.push(slug.slug)
    })

    return canonicalList
  }

  return (
    <MetaDirectives
      title={data.metaTitle}
      lang={data.node_locale}
      description={data.metaDescription}
      canonical={slugMaker()}
      ogUrl={data.slug}
      ogTitle={data.metaTitle}
      robots={props.pageContext.robots}
      // schemaOrg={data.metaJson}
      schemaOrgText={
        data.schemaOrgText !== null ? data.schemaOrgText.schemaOrgText : null
      }
    />
  )
}

const SectorPage = ({ data, pageContext }) => {
  const queryData =
    data.allContentfulEdc22ContentPageImportedEdControlsPages.nodes[0]

  const imageBlockArray = queryData.extraBlocks.filter(object => {
    return object.image !== null
  })
  const textBlockArray = queryData.extraBlocks.filter(object => {
    return object.image === null
  })

  const sliderData = queryData.logoBanner

  const slugs = data.General.nodes

  const slugMaker = () => {
    let canonicalList = []
    slugs.forEach(slug => {
      canonicalList.push(slug.slug)
    })
    return canonicalList
  }

  return (
    <Layout urlContent={slugMaker()}>
      <div
        className={`bg-[#f7f9fc] md:py-[80px] md:px-[108px] py-[40px] ${styles.sectorWrapper}`}
      >
        <div
          className={
            "flex lg:gap-[20px] lg:flex-row flex-col max-w-[1224px] lg:h-[450px] lg:justify-between justify-center lg:mx-auto mx-auto lg:px-0 px-3"
          }
        >
          <div className="lg:w-[500px] lg:max-w-[500px] w-[100%] h-[auto] lg:mb-0 mb-[100px] lg:mx-0 mx-auto flex-col justify-center leading-loose">
            <div className={"lg:px-0 lg:pt-0 my-auto lg:mb-[20px]"}>
              <RenderRichContent content={queryData.textOverHeader} />
            </div>
              {queryData.clientImage ? <img src={queryData.clientImage.file.url} alt="image" width="216"/> : <></>}
            {queryData.extraBlocks.map((block, index) => {
              if (block.demoRequestText) {
                return <FreeDemoBarSector data={block} key={index} />
              }
              return null
            })}
          </div>
          <div className={"lg:w-[600px] lg:max-w-[600px] lg:mx-0 mx-auto "}>
            <img
              src={queryData.headerImage[0].file.url}
              alt={
                queryData.headerImage[0].description
                  ? queryData.headerImage[0].description
                  : "image"
              }
              className="rounded-2xl block lg:w-[600px] w-auto lg:h-[450px] h-auto mb-0 "
            />
          </div>
        </div>
      </div>

      {queryData.extraBlocks.map((block, index) => {
        if (block.demoRequestText) {
          return <DemoRequestBanner data={block} key={index} />
        } 
        else if (
          block.internal?.type === "ContentfulEdc22ContentBlockImageAndTextLink" &&
          block.textBlockCondition === "workingdayblock"
        ) {
          return (
            <div className={`text-[#FFFFFF] ${styles.WorkingDayBackground}`}>
              <WorkingdayImageTextBlock data={block} key={index} />
            </div>
          )
        }
        else if (
          block.internal?.type === "ContentfulEdc22ContentBlockImageAndTextLink"
        ) {
          return (
            <ImageTextBlockSector data={block} key={index} number={index} />
          )
        } else if (
          block.internal?.type === "ContentfulEdc22ContentBlockLicenseBlock"
        ) {
          return (
            <div className="lg:flex lg:max-w-[1170px] lg:justify-center lg:mx-auto mx-4 gap-4 mb-20">
              <NewPricingCard
                data={block}
                index={index}
                licenseType={"SecurEd"}
                featureList={block.newFeatureListForStartBlock}
                licenseDescription={block.licenseTitleStart}
                color={"#000000"}
                currencyValue={block.node_locale === "en" ? "£" : "€"}
                price={block.priceStart}
                talkToSales={block.talkToAnExpertButtonText}
                demoPageSlug={block.demoPage.slug}
                paymentCondition={block.paymentCondition}
                addStyling={"shadow-xl"}
              />
              <NewPricingCard
                data={block}
                index={index}
                licenseType={"SecurEd"}
                featureList={block.newFeatureListForProBlock}
                licenseDescription={block.licenseTitlePro}
                color={"#000000"}
                currencyValue={block.node_locale === "en" ? "£" : "€"}
                price={block.pricePro}
                talkToSales={block.talkToAnExpertButtonText}
                demoPageSlug={block.demoPage.slug}
                paymentCondition={block.paymentCondition}
                addStyling={"shadow-xl"}
              />
              <NewPricingCard
                data={block}
                index={index}
                licenseType={"SecurEd"}
                featureList={block.newFeatureListForExpertBlock}
                licenseDescription={block.licenseTitleExpert}
                color={"#000000"}
                currencyValue={block.node_locale === "en" ? "£" : "€"}
                price={block.priceExpert}
                talkToSales={block.talkToAnExpertButtonText}
                demoPageSlug={block.demoPage.slug}
                paymentCondition={block.paymentCondition}
                addStyling={"shadow-xl"}
              />
            </div>
          )
        } else if (block.internal?.type === "ContentfulContentBlockVideo") {
          return (
            <div
              className={`max-w-[1224px] mx-auto text-center lg:my-[60px] + ${styles.videoBlock}`}
            >
              <div className="">
                <RenderRichContent content={block.videoHeader} />
              </div>
              <div className="max-w-[826px] mx-auto rounded-xl ">
                <RenderRichContent content={block.embeddedVideo} />
              </div>
            </div>
          )
        } else if (
          block.internal?.type === "ContentfulEdc22ContentBlockSlider" &&
          block.sliderItems[0].doubleImage !== null
        ) {
          return <QuotesComponent data={block} key={index} />
        } else if (
          block.internal?.type === "ContentfulEdc22ContentBlockSlider" &&
          block.sliderType === "Card Slider" &&
          block.sliderTitle === "Content Block > Customer feedback slider"
        ) {
          return <CustomerSlider data={block} key={index} hideImpact={true} />
        } else if (
          block.internal?.type === "ContentfulEdc22ContentBlockSlider" &&
          block.sliderType === "Logo Slider"
        ) {
          return <NewSlider data={block} />
        }
        return null
      })}
      <div className="mx-auto">
        <ReferenceContainer data={queryData.extraBlocks} />
      </div>

      {/* New Blog Reference Section */}
      {queryData.blogReference && queryData.blogReference.length > 0 && (
        <section className="max-w-[1218px] mx-auto lg:my-[75px] my-[45px] px-[16px]">
          <div className={styles.blogHeaderSection}>
            <RenderRichContent content={queryData.blogSectionTitle} />
          </div>
          <div className="grid grid-cols-1 gap-x-10 lg:gap-y-0 gap-y-10 mt-10 sm:grid-cols-2 lg:grid-cols-3">
            {queryData.blogReference.map((card, index) => (
              <HomepageBlogCard data={card} key={index} />
            ))}
          </div>
        </section>
      )}
    </Layout>
  )
}

export default SectorPage

export const query = graphql`
  query SectorPageQuery($locale: String, $slug: String, $contentfulID: String) {
    General: allContentfulEdc22ContentPageImportedEdControlsPages(
      filter: { contentful_id: { eq: $contentfulID } }
    ) {
      nodes {
        slug
        node_locale
      }
    }
    allContentfulEdc22ContentPageImportedEdControlsPages(
      filter: {
        selectCategory: { eq: "Sector page" }
        node_locale: { eq: $locale }
        slug: { eq: $slug }
      }
    ) {
      nodes {
        blogSectionTitle {
          raw
        }
        blogReference {
          ... on ContentfulEdc22ContentPageEBooksBlogs {
            slug
            articleHeaderImage {
              gatsbyImageData
              title
              file {
                url
              }
            }
            downloadButtonText
            slug
            contentType
            title
            node_locale
            articleShortIntro {
              raw
            }
          }
          ... on ContentfulEdc22ContentPageImportedEdControlsPages {
            id
            articleTitle
            articleContent {
              raw
            }
            headerImage {
              file {
                url
              }
            }
            shortIntroForOverviewPage {
              raw
            }
            titleForOverviewPage
            slug
            selectCategory
            eBookBlogCheck
          }
        }
        schemaOrgText {
          schemaOrgText
        }
        clientImage {
          file {
            url
          }
        }
        logoBanner {
          node_locale
          sliderType
          sliderTitle
          sliderIntro {
            raw
          }
          sliderItems {
            image {
              gatsbyImageData(resizingBehavior: SCALE, jpegProgressive: true)
            }
            imageLink
            node_locale
          }
        }
        freeDemoBannerText
        articleContent {
          raw
        }
        articleTitle
        extraBlocks {
          ... on ContentfulEdc22ContentBlockLicenseBlock {
            internal {
              type
            }
            demoPage {
              slug
            }
            chooseLicenseButtonText
            freeTrialPage {
              slug
            }
            newFeatureListForProBlock {
              raw
            }
            newFeatureListForExpertBlock {
              raw
            }
            newFeatureListForStartBlock {
              raw
            }
            chooseLicenseButtonText
            paymentCondition
            node_locale
            buttonRequestDemo {
              buttonText
              internalPageReference {
                ... on ContentfulEdc22ContentPageContactDemoForm {
                  id
                  slug
                }
                ... on ContentfulEdc22OverviewPageCasesAndReferences {
                  id
                  slug
                }
              }
            }
            textBelowLite
            priceLite
            tryItForFreeLinkText
            talkToAnExpertButtonText
            keepMePostedButtonText
            comingSoonQuote
            textBelowExpert
            textBelowPro
            textBelowStart
            licenseTitleExpert
            licenseTitlePro
            licenseTitleStart
            licenseFreeTrialText
            licenseFreeTrialDescription
            priceFreeTrial
            buttonTextFreeTrial
            priceExpert
            pricePro
            priceStart
            licenseDescription
            licenseTabTitle
            expertButtonQueryAddOn
            proButtonQueryAddOn
            startButtonQueryAddOn
            licenseOptionsReference {
              closeSvg {
                file {
                  url
                }
              }
              checkSvg {
                file {
                  url
                }
              }
              startFeaturesList
              freeTrialFeatures
              startExcludedFeatures
              proFeaturesList
              proExcludedFeatures
              expertFeaturesList
              liteFeaturesList
            }
          }
          ... on ContentfulEdc22ContentBlockSlider {
            sliderType
            sliderTitle
            internal {
              type
            }
            sliderIntro {
              raw
            }
            sliderItems {
              text {
                raw
              }
              usp1 {
                raw
              }
              usp2 {
                raw
              }
              image {
                gatsbyImageData
                file {
                  url
                }
                description
              }
              doubleImage {
                file {
                  url
                }
                description
              }
              text {
                raw
              }
            }
          }
          ... on ContentfulContentBlockVideo {
            internal {
              type
            }
            videoHeader {
              raw
            }
            embeddedVideo {
              raw
            }
          }
          ... on ContentfulEdc22ContentPageImportedEdControlsPages {
            titleForOverviewPage
            slug
            headerImage {
              description
              gatsbyImageData(placeholder: BLURRED)
            }
            companyName
          }
          ... on ContentfulEdc22ContentBlockImageAndTextLink {
            textBlockCondition
            imageLeftOrRight
            internal {
              type
            }
            quoteText
            image {
              description
              file {
                url
              }
              gatsbyImageData(
                height: 600
                layout: CONSTRAINED
                cornerRadius: 16
              )
            }
            blockTitle
            imageLink
            text {
              raw
            }
          }
         ... on ContentfulEdc22ContentBlockRequestDemo {
            colleagueFunctionTitle
            colleagueName
            demoRequestText {
              raw
            }
            backgroundImage {
              file {
                url
              }
            }
            demoRequestPage {
              slug
            }
            colleagueImage {
              gatsbyImageData(placeholder: DOMINANT_COLOR)
              description
            }
            extraBlocks {
              buttonColor
              buttonText
              buttonUrl
            }
          }
        }
        headerImage {
          description
          file {
            url
          }
          gatsbyImageData
        }
        metaDescription
        metaTitle
        selectCategory
        slug
        textOverHeader {
          raw
        }
        node_locale
      }
    }
  }
`